import { avatarRecipe } from "./avatar";
import { comboboxRecipe } from "./combobox";
import { dialogRecipe } from "./dialog";
import { pinInputRecipe } from "./pin-input";
import { radioCardRecipe } from "./radio-card";
import { scrollAreaRecipe } from "./scroll-area";
import { segmentGroupRecipe } from "./segment-group";
import { selectableTileRecipe } from "./selectable-tile";
import { statusRecipe } from "./status";
import { tabsRecipe } from "./tabs";
import { tagRecipe } from "./tag";
import { tooltipRecipe } from "./tooltip";

export const slotRecipes = {
  avatar: avatarRecipe,
  combobox: comboboxRecipe,
  dialog: dialogRecipe,
  pinInput: pinInputRecipe,
  radioCard: radioCardRecipe,
  scrollArea: scrollAreaRecipe,
  selectableTile: selectableTileRecipe,
  segmentGroup: segmentGroupRecipe,
  status: statusRecipe,
  tabs: tabsRecipe,
  tag: tagRecipe,
  tooltip: tooltipRecipe,
};
